<template>
  <el-dialog
    title="新增天使费用"
    :visible.sync="visible"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @close="$emit('close')"
    width="1200px"
  >
    <div style="padding: 16px;">
      <dialogPanel>
        <ChapterHead :level="2">基本信息</ChapterHead>
        <el-form ref="formRef" :model="form" :rules="formRules" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="患儿编号" prop="childId">
                <el-input :value="formData.childId" disabled size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="患儿姓名" prop="childName">
                <el-input :value="formData.childName" disabled size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出生日期" prop="birthday">
                <el-input :value="formData.birthday" disabled size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="病种" prop="afterDiseasesName">
                <el-input :value="formData.afterDiseasesName" disabled size="small" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="救助限额" prop="helpQuota">
                <el-input :value="parseFloat(formData.helpQuota || 0).toFixed(2)" disabled size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="已申请救助金额" prop="useHelpAmount">
                <el-input :value="parseFloat(formData.usedAmount || 0).toFixed(2)" disabled size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="剩余救助金额" prop="remainingSum">
                <el-input :value="((formData.helpQuota || 0) - (formData.usedAmount || 0)).toFixed(2)" disabled size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="期次" prop="curStages">
                <el-input :value="formData.curStages" disabled size="small" />
              </el-form-item>
            </el-col>
          </el-row>
          <ChapterHead :level="2">住院号填写</ChapterHead>
          <el-row>
            <el-col :span="6">
              <el-form-item label="住院号" prop="inHospitalNo">
                <el-input v-model="form.inHospitalNo" size="small" />
              </el-form-item>
            </el-col>
	          <el-col :span="6">
		          <el-form-item label="入院时间" prop="inHospitalTime">
			          <el-date-picker v-model="form.inHospitalTime" type="date" size="small"
			                          value-format="timestamp" format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions">
			          </el-date-picker>
		          </el-form-item>
	          </el-col>
            <el-col :span="6"  v-show="formData.hospitalIsAuto==1 && formData.isShowInHospitalNumber == 1">
              <el-form-item label="住院流水号" prop="inHospitalSerialNo" :rules="[{required: formData.hospitalIsAuto==1 && formData.isShowInHospitalNumber == 1, message: '请输入住院流水号', trigger: 'blur' }]">
                   <el-input v-model="form.inHospitalSerialNo" size="small" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </dialogPanel>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button :loading="btnLoading" @click="$emit('close')">取 消</el-button>
      <el-button :loading="btnLoading" type="primary" @click="saveNewOutlay">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveNewOutlayAndStages, uniqueInHospitalNo,uniqueInHospitalSerialNo } from "@/util/api.js";

import dialogPanel from "@/components/business/dialogPanel";
import ChapterHead from "@/components/business/ChapterHead";

export default {
  components: {
    dialogPanel,
    ChapterHead
  },
  props: {
    visible: false,
    formData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
	    pickerOptions: {
		    disabledDate(time) {
			    return time.getTime() > Date.now();
		    }
	    },
      form: {},
      formRules: {
        inHospitalNo: [{ required: true, message: '请填写住院号', trigger: 'change' }],
	      inHospitalTime: [{ required: true, message: '请选择入院时间', trigger: 'change' }],
        inHospitalSerialNo: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.detailForm1.isShowInHospitalNumber == 1 && !value) {
                callback(new Error('请输入住院流水号'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },
      inHospitalNo: null,
      btnLoading: false
    }
  },
  methods: {
    async saveNewOutlay() {
      if (this.form.inHospitalNo) {
        if (this.formData.hospitalIsAuto == 1 && this.formData.isShowInHospitalNumber == 1) {
          try {
            await this.uniqueInHospitalSerialNo();
          } catch (error) {
            return; // 校验失败时终止流程
          }
        }
        uniqueInHospitalNo({
          hospitalId: this.form.hospitalId,
          inHospitalNo: this.form.inHospitalNo,
          inHospitalTime: this.form.inHospitalTime
        }).then(res => {
          if (res.msgCode == 200) {
            if (res.responseData == 1) {
              let params = {};
              params.helpReqId = this.formData.helpReqId;
              params.belongProject = 'AY1002';
              params.outlayType = 1;
              params.outlayStatus = 0;
              params.hospitalId = this.formData.hospitalId;
              params.inHospitalNo = this.form.inHospitalNo;
              params.inHospitalTime = this.form.inHospitalTime;
              params.inHospitalSerialNo = this.form.inHospitalSerialNo;
              this.btnLoading = true;
              saveNewOutlayAndStages(params).then(res => {
                this.btnLoading = false;
                if (res.msgCode == 200) {
                  this.$emit('success', res.responseData);
                } else {
                  this.$message.error(res.msg);
                }
              });
            } else {
              this.$message.error('住院号已存在！');
            }
          } else {
            this.$message.error(res.msg)
          }
        });
      } else {
        this.$message.error('住院号不能为空！');
      }
    },

    /**
     * 校验住院流水号
     */
    uniqueInHospitalSerialNo() {
      return new Promise((resolve, reject) => {
        if (!this.form.inHospitalSerialNo) {
          this.$message.error('住院流水号不能为空！');
          return reject();
        }
        uniqueInHospitalSerialNo({
          hospitalId: this.formData.hospitalId,
          childName: this.formData.childName,
          inHospitalTime: this.form.inHospitalTime,
          inHospitalSerialNo: this.form.inHospitalSerialNo,
        }).then(result => {
          if (result.msgCode != 200 || !result.responseData) {
            this.$message.error('住院流水号校验失败！');
            reject();
          } else {
            resolve();
          }
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../../common/form.scss';
</style>



// WEBPACK FOOTER //
// src/pages/outlay/cure/CureAngleAutoOutlay.vue